"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnDetailsTagsValue = exports.ColumnInlineTagEditor = exports.getTagNamesFromMap = exports.convertArrayToMap = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
// helper function to convert a tag array into a map of tagname and tagCount.
function convertArrayToMap(tags) {
    var tagMap = new Map();
    if (tags) {
        tags.forEach(function (tag) {
            var _a;
            var originalTagCount = (_a = tagMap.get(tag)) !== null && _a !== void 0 ? _a : 0;
            tagMap.set(tag, originalTagCount + 1);
        });
    }
    return tagMap;
}
exports.convertArrayToMap = convertArrayToMap;
function getTagNamesFromMap(tags) {
    return Array.from(tags.keys());
}
exports.getTagNamesFromMap = getTagNamesFromMap;
function ColumnInlineTagEditor(props) {
    var _this = this;
    var columnLuid = props.columnLuid, onUpdate = props.onUpdate;
    var _a = react_1.default.useContext(data_catalog_shared_1.ApiRequestsContext), searchMatchingTags = _a.searchMatchingTags, updateColumnTags = _a.updateColumnTags;
    var _b = react_1.default.useState(props.tags), tags = _b[0], setTags = _b[1];
    var searchMatchingTagsWrapper = react_1.default.useCallback(function (partialText) { return searchMatchingTags({ partialText: partialText, maxItems: 5, startIndex: 0 }); }, [searchMatchingTags]);
    var onSave = react_1.default.useCallback(function (editorState) { return __awaiter(_this, void 0, void 0, function () {
        var _a, tagsToAdd, tagsToRemove;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (0, vizportalclient_common_components_1.getTagListsForVizportalApi)({ oldTags: convertArrayToMap(tags), newTags: editorState.tags }), tagsToAdd = _a.tagsToAdd, tagsToRemove = _a.tagsToRemove;
                    if (tagsToAdd.length < 1 && tagsToRemove.length < 1) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, updateColumnTags({ luids: [columnLuid], tagsToAdd: tagsToAdd, tagsToRemove: tagsToRemove })];
                case 1:
                    _b.sent();
                    onUpdate();
                    setTags(getTagNamesFromMap(editorState.tags));
                    return [2 /*return*/];
            }
        });
    }); }, [columnLuid, tags, onUpdate, updateColumnTags]);
    var logic = (0, vizportalclient_common_components_1.useInlineEditor)({
        editorStateWhenEnteringEditMode: { tags: convertArrayToMap(tags), suggestions: [], partialText: null },
        canEdit: props.canEditTags,
        canSaveFn: function (state) {
            var _a = (0, vizportalclient_common_components_1.getTagListsForVizportalApi)({ oldTags: convertArrayToMap(tags), newTags: state.tags }), tagsToAdd = _a.tagsToAdd, tagsToRemove = _a.tagsToRemove;
            return tagsToAdd.length > 0 || tagsToRemove.length > 0;
        },
        onSave: onSave
    });
    return (react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsProperty, null,
        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.Tags()),
        (0, vizportalclient_common_components_1.isEditMode)(logic)
            ? (react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsTableCell, null,
                react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsTextAreaWrapper, null,
                    react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsTagsEditorWrapper, null,
                        react_1.default.createElement(vizportalclient_common_components_1.TagsEditor, { editorState: logic.editorState, setEditorState: logic.setEditorStateWithinEditMode, searchMatchingTags: searchMatchingTagsWrapper, disableEditor: logic.isActionBusy, style: { height: '100%' }, itemCount: 1 }))),
                react_1.default.createElement(ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsWrapper, null,
                    react_1.default.createElement(SaveAndCancelButtonsFlexWrapper, null,
                        react_1.default.createElement("div", { style: { marginRight: widgets_1.TabStyles.Spacing.MediumSpace } },
                            react_1.default.createElement(vizportalclient_common_components_1.InlineEditorCancelButton, __assign({}, logic))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(vizportalclient_common_components_1.InlineEditorSaveButton, __assign({}, logic))))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(exports.ColumnDetailsTagsValue, null,
                react_1.default.createElement(ReadonlyTags, { savedTags: tags })),
            react_1.default.createElement(vizportalclient_common_components_1.InlineEditorEditButton, __assign({}, logic, { editButtonLabel: Localize_1.Messages.EditTags() }))))));
}
exports.ColumnInlineTagEditor = ColumnInlineTagEditor;
function ReadonlyTags(props) {
    return props.savedTags.length > 0
        ? react_1.default.createElement("div", { "data-tb-test-id": 'readonly-tags', style: { maxHeight: ColumnAndFieldDetailsStyles_1.descriptionMaxHeight } }, props.savedTags.join(', '))
        : react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsPlaceholder, null, Localize_1.Messages.NoTagsAvailable());
}
exports.ColumnDetailsTagsValue = (0, data_catalog_shared_1.divWithStyle)('ColumnDetailsTagsValue', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    overflowY: 'auto',
    wordBreak: 'break-word',
});
var SaveAndCancelButtonsFlexWrapper = (0, data_catalog_shared_1.divWithStyle)('SaveAndCancelButtonsFlexWrapper', __assign(__assign({}, ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsFlexWrapperSharedStyle), { marginTop: widgets_1.TabStyles.Spacing.DefaultSpace }));
//# sourceMappingURL=ColumnInlineTagEditor.js.map